import React from 'react'
import Skeletons from '../../../../product/components/Skeletons'

function CommentSkeleton() {
    return (
        <div className="productViewSkeleton">
            <div className="pvsAct d-flex align-items-center w-100">
                <div className="w-75">
                    <Skeletons type="input" />
                </div>
                <div className="w-25">
                    <Skeletons type="input" />
                </div>
            </div>
            <hr className="mb-5" />
            <div className="mb-3">
                <Skeletons type="box" />
            </div>
            <div className="mb-3">
                <Skeletons type="box" />
            </div>
            <div className="mb-3">
                <Skeletons type="box" />
            </div>
            <div className="mb-3">
                <Skeletons type="box" />
            </div>
            <div className="mb-3">
                <Skeletons type="box" />
            </div>
        </div>
    )
}

export default CommentSkeleton
